var map = {
	"./alerta-amarelo.png": 198,
	"./alerta-azul.png": 316,
	"./alerta-cinza.png": 612,
	"./alerta-preto.png": 613,
	"./alerta-roxo.png": 317,
	"./alerta-verde.png": 318,
	"./alerta-vermelho.png": 319,
	"./avulso-amarelo.png": 455,
	"./avulso-azul.png": 245,
	"./avulso-cinza.png": 195,
	"./avulso-roxo.png": 456,
	"./avulso-verde.png": 457,
	"./avulso-vermelho.png": 458,
	"./ceu-marker-gray.png": 614,
	"./circulo-alerta.png": 615,
	"./ecoponto-amarelo.png": 616,
	"./ecoponto-azul.png": 314,
	"./ecoponto-cinza.png": 193,
	"./ecoponto-roxo.png": 617,
	"./ecoponto-verde.png": 618,
	"./ecoponto-vermelho.png": 619,
	"./inconformidade-amarelo.png": 320,
	"./inconformidade-azul.png": 321,
	"./inconformidade-cinza.png": 620,
	"./inconformidade-preto.png": 621,
	"./inconformidade-roxo.png": 322,
	"./inconformidade-verde.png": 323,
	"./inconformidade-vermelho.png": 324,
	"./marker-close.png": 325,
	"./marker-destination.png": 196,
	"./marker-ocurrency.png": 326,
	"./marker-pause.png": 327,
	"./marker-start.png": 328,
	"./marker-unload.png": 197,
	"./marker-warning.png": 622,
	"./planotrabalho-amarelo.png": 623,
	"./planotrabalho-azul.png": 315,
	"./planotrabalho-cinza.png": 194,
	"./planotrabalho-roxo.png": 624,
	"./planotrabalho-verde.png": 625,
	"./planotrabalho-vermelho.png": 626,
	"./point-veicle.png": 627,
	"./point.png": 199,
	"./veiculo-amarelo.png": 459,
	"./veiculo-azul.png": 246,
	"./veiculo-cinza.png": 628,
	"./veiculo-roxo.png": 460,
	"./veiculo-verde.png": 461,
	"./veiculo-vermelho.png": 462
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68;